// @flow
import * as React from 'react';
import Field from 'app/common/react/ui/experimental/Field';
import { TextField as TextControl } from 'gestalt';

type Props = {
  description?: string,
  disabled?: boolean,
  error?: ?React.Node,
  id: string,
  label?: string,
  onChange: ({ event: SyntheticInputEvent<HTMLInputElement>, value: string }) => void,
  required?: boolean,
  onLabelTouch?: () => void,
  type?: 'date' | 'email' | 'number' | 'password' | 'text' | 'url',
  value?: string,
};

export class TextField extends React.Component<Props> {
  textfield: ?HTMLElement;

  render() {
    const { description, error, id, label, required = false, onLabelTouch, ...props } = this.props;

    return (
      <Field
        description={description}
        error={error}
        id={id}
        label={label}
        required={required}
        onLabelTouch={onLabelTouch}
      >
        <TextControl
          {...props}
          hasError={!!error}
          id={id}
          ref={(comp) => {
            this.textfield = comp ? comp.textfield : null;
          }}
        />
      </Field>
    );
  }
}

export default TextField;
